import { useState } from "react";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";

export const AddItemDialog = ({ section, onAdd, testId }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [qty, setQty] = useState("");
  const [toTemplate, setToTemplate] = useState(true);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    const ok = await onAdd({ section, name: name.trim(), expected_qty: qty === "" ? null : parseInt(qty, 10), add_to_template: toTemplate });
    setBusy(false);
    if (ok) { setOpen(false); setName(""); setQty(""); }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={testId}
        className="w-full min-h-[48px] rounded-lg border border-dashed border-[#2A2E39] text-slate-400 hover:text-[#A9B26A] hover:border-[#636b2f] flex items-center justify-center gap-2 text-sm font-semibold transition-colors">
        <Plus className="w-4 h-4" /> Adicionar item
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#15181E] border-[#2A2E39] text-white">
          <DialogHeader>
            <DialogTitle className="font-display uppercase tracking-wide">Novo item</DialogTitle>
            <p className="text-sm text-slate-400">{section}</p>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="item-name">Nome do item</Label>
              <Input id="item-name" autoFocus value={name} onChange={(e) => setName(e.target.value)} className="h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid="add-item-name-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="item-qty">Quantidade esperada (opcional)</Label>
              <Input id="item-qty" type="number" inputMode="numeric" min="0" value={qty} onChange={(e) => setQty(e.target.value)} className="h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid="add-item-qty-input" />
            </div>
            <label className="flex items-center justify-between gap-3 rounded-md border border-[#2A2E39] p-3">
              <span className="text-sm text-slate-300">Incluir também nos próximos shows</span>
              <Switch checked={toTemplate} onCheckedChange={setToTemplate} data-testid="add-item-template-switch" />
            </label>
            <DialogFooter>
              <Button type="submit" disabled={busy || !name.trim()} className="h-12 w-full bg-[#636b2f] text-white hover:bg-[#737c37] font-bold" data-testid="add-item-submit-btn">
                {busy ? "Salvando..." : "Adicionar"}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
